import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitComas',
  standalone: false
})
export class SplitComasPipe implements PipeTransform {

  transform(valor: string | null | undefined): string[] {
    if (!valor) {
      return [];
    }
    return valor
      .split(',')
      .map(item => item.trim())
      .filter(item => item.length > 0);
  }

}
